import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import DashboardPage from "./DashboardPage";
import AutomationsIndexPage from '../automations/AutomationsIndexPage';
import ViewAutomationPage from '../automations/ViewAutomationPage';
import CreateAutomationPage from '../automations/CreateAutomationPage';
import OperationsIndex from '../operations/OperationsIndex';
import OperationsNewPage from '../operations/OperationsNewPage';
import CreateOperationPage from '../operations/CreateOperationPage';
import CustomerOperationPage from '../operations/customers/CustomerOperationPage/CustomerOperationPage';
import OrderOperationPage from '../operations/customers/OrderOperationPage/OrderOperationPage';
import EditOperationPage from '../operations/EditOperationPage';
import ViewOperationPage from '../operations/ViewOperationPage';
import ViewOperationPageCustomer from '../operations/customers/CustomerOperationPage/ViewOperationPageCustomer';
import ViewOperationPageOrder from '../operations/customers/OrderOperationPage/ViewOperationPageOrder';
import ValidationsIndexPage from '../validations/ValidationsIndexPage';
import ValidationsNewPage from '../validations/ValidationsNewPage';
import ValidationsViewPage from '../validations/ValidationsViewPage';
import ValidationsEditPage from '../validations/ValidationsEditPage';
import TagGroupsIndexPage from '../tag-groups/TagGroupsIndexPage';
import TagGroupPage from '../tag-groups/TagGroupPage';
import TagGroupViewPage from '../tag-groups/TagGroupViewPage';
import TagExplorerPage from '../tag-explorer/TagExplorerPage';

// Scenarios
import ScenarioRemovePage from '../operations/ScenarioRemovePage';
import ScenarioMergePage from '../operations/ScenarioMergePage';
import ScenarioChangePrefixPage from '../operations/ScenarioChangePrefixPage';
import ScenarioFixTagCapitalizationPage from '../operations/ScenarioFixTagCapitalizationPage';
import ScenarioTagTextReplacementScenarioPage from '../operations/ScenarioTagTextReplacementScenarioPage';

// Tag Rules
import TagRulePage from '../tag-rules/TagRulePage';
import TagRulesIndexPage from '../tag-rules/TagRulesIndexPage';
import TagRulesNewPage from '../tag-rules/TagRulesNewPage';
import TagRuleViewPage from '../tag-rules/TagRuleViewPage';
import AutoTagProductByTypePage from '../tag-rules/rules/AutoTagProductByTypePage';

// Bulk Operations
import BulkOperationViewPage from '../bulk-operations/BulkOperationViewPage';

import CustomBulkOperationPage from '../operations/bulk/CustomBulkOperationPage';

// Validation Rules
import ValidationRulesIndexPage from '../validation-rules/ValidationRulesIndexPage';
import ValidationRulesCreatePage from '../validation-rules/ValidationRulesCreatePage';
import SmartCollectionProductTagsValidationRulePage from '../validation-rules/rules/SmartCollectionProductTagsValidationRulePage';
import SmartCollectionProductTagsValidationRuleViewPage from '../validation-rules/rules/SmartCollectionProductTagsValidationRuleViewPage';

import PlansPage from '../PlansPage';
import ChangePlanPage from '../ChangePlanPage';
import ChangePlanFreePage from '../ChangePlanFreePage';
import SettingsPage from '../SettingsPage';
import TagPage from '../TagPage';
import Help from '../Help';
import Tutorials from '../Tutorials';
import { withRouter } from "react-router";

function Routes() {

  return (
    <Switch>
      <Route exact path='/'>{withRouter(DashboardPage)}</Route>
      <Route exact path='/automations'>{withRouter(AutomationsIndexPage)}</Route>
      <Route exact path='/automations/new'>{withRouter(CreateAutomationPage)}</Route>
      <Route exact path='/automations/:id'>{withRouter(ViewAutomationPage)}</Route>

      <Route exact path='/operations'>{withRouter(OperationsIndex)}</Route>
      <Route exact path='/operations/new'>{withRouter(OperationsNewPage)}</Route>
      {/* <Route exact path='/operations/new' >{withRouter(OperationsCreateMain)}</Route> */}
      <Route exact path='/operations/new/custom' component={withRouter(CreateOperationPage)} />
      <Route exact path='/operations/new/remove' component={withRouter(ScenarioRemovePage)} />
      <Route exact path='/operations/customer/new/remove' component={withRouter(ScenarioRemovePage)} />
      <Route exact path='/operations/new/merge' component={withRouter(ScenarioMergePage)} />
      <Route exact path='/operations/new/change-prefix' component={withRouter(ScenarioChangePrefixPage)} />

      {/* Scenarios */}
      <Route exact path='/scenarios/fix-capitalization' component={withRouter(ScenarioFixTagCapitalizationPage)} />
      <Route exact path='/scenarios/text-replacement' component={withRouter(ScenarioTagTextReplacementScenarioPage)} />

      <Route exact path='/operations/customer/new/merge' component={withRouter(ScenarioMergePage)} />
      <Route exact path='/operations/customer/new/custom' component={withRouter(CustomerOperationPage)} />
      <Route exact path='/operations/customer/:id' component={withRouter(ViewOperationPageCustomer)} />
      <Route exact path='/operations/customer/:id/edit' component={withRouter(CustomerOperationPage)} />

      <Route exact path='/operations/order/new/merge' component={withRouter(ScenarioMergePage)} />
      <Route exact path='/operations/order/new/custom' component={withRouter(OrderOperationPage)} />
      <Route exact path='/operations/order/:id' component={withRouter(ViewOperationPageOrder)} />
      <Route exact path='/operations/order/:id/edit' component={withRouter(OrderOperationPage)} />

      <Route exact path='/operations/:id' component={withRouter(ViewOperationPage)} />
      <Route exact path='/operations/:id/edit' component={withRouter(EditOperationPage)} />
      <Route exact path='/help' component={withRouter(Help)} />
      <Route exact path='/tutorials' component={withRouter(Tutorials)} />
      <Route exact path='/tag-groups' component={withRouter(TagGroupsIndexPage)} />
      <Route exact path='/tag-groups/new' component={withRouter(TagGroupPage)} />
      <Route exact path='/tag-groups/edit/:id' component={withRouter(TagGroupPage)} />
      <Route exact path='/tag-groups/:id' component={withRouter(TagGroupViewPage)} />

      { /* Tag Explorer */}
      <Route exact path='/explorer' component={withRouter(TagExplorerPage)} />


      {/* Tag Rules */}
      <Route exact path='/tag-rules/new/:ruleType' component={withRouter(TagRulePage)} />
      <Route exact path='/tag-rules/modify/:id' component={withRouter(TagRulePage)} />

      <Route path='/tag-rules' exact component={withRouter(TagRulesIndexPage)} />
      <Route path='/tag-rules/list' exact component={withRouter(TagRulesNewPage)} />
      <Route path='/tag-rules/:id' exact component={withRouter(TagRuleViewPage)} />

      {/* Bulk Operations */}
      <Route path='/bulk-operations/:id' exact component={withRouter(BulkOperationViewPage)} />

      <Route exact path='/tag-rules/edit/AutoTagProductByType/:id' component={withRouter(AutoTagProductByTypePage)} />
      <Route exact path='/tag-rules/create/AutoTagProductByType' component={withRouter(AutoTagProductByTypePage)} />

      {/* Validation Rules */}
      <Route exact path='/validation-rules' component={withRouter(ValidationRulesIndexPage)} />
      <Route exact path='/validation-rules/create' component={withRouter(ValidationRulesCreatePage)} />

      <Route exact path='/validation-rules/edit/SmartCollectionProductTagsValidation/:id' component={withRouter(SmartCollectionProductTagsValidationRulePage)} />
      <Route exact path='/validation-rules/create/SmartCollectionProductTagsValidation' component={withRouter(SmartCollectionProductTagsValidationRulePage)} />
      <Route exact path='/validation-rules/SmartCollectionProductTagsValidation/:id' component={withRouter(SmartCollectionProductTagsValidationRuleViewPage)} />


      <Route exact path='/operations/bulk/custom/edit/:id' component={withRouter(CustomBulkOperationPage)} />
      <Route exact path='/operations/bulk/custom/new' component={withRouter(CustomBulkOperationPage)} />

      <Route exact path='/validations' component={withRouter(ValidationsIndexPage)} />
      <Route exact path='/validations/new' component={withRouter(ValidationsNewPage)} />
      <Route exact path='/validations/:id' component={withRouter(ValidationsViewPage)} />
      <Route exact path='/validations/:id/edit' component={withRouter(ValidationsEditPage)} />
      <Route exact path='/plan' component={withRouter(PlansPage)} />
      <Route exact path='/change-plan' component={withRouter(ChangePlanPage)} />
      <Route exact path='/change-plan-free' component={withRouter(ChangePlanFreePage)} />
      <Route exact path='/settings' component={withRouter(SettingsPage)} />
      <Route exact path='/tag' component={withRouter(TagPage)} />
    </Switch>
  )
}

export default Routes;